<template>
  <div class="TipsNews">
    <top-bar title="停水信息" hasBack></top-bar>
    <div class="content">
      <img src="../../assets/imgs/gonggao0425.png" class="gonggao" alt="">
      <div class="TipsNews-text">
        <div class="TipsNews-text-item">
          2021年4月1日停水信息
        </div>
        <div class="TipsNews-text-item">
          2021.3.23
        </div>
      </div>

      <van-icon name="arrow" class="TipsNews-back" />
    </div>
    <div class="content">
      <img src="../../assets/imgs/gonggao0425.png" class="gonggao" alt="">
      <div class="TipsNews-text">
        <div class="TipsNews-text-item">
          2021年4月1日停水信息
        </div>
        <div class="TipsNews-text-item">
          2021.3.23
        </div>
      </div>

      <van-icon name="arrow" class="TipsNews-back" />
    </div>
    <div class="content">
      <img src="../../assets/imgs/gonggao0425.png" class="gonggao" alt="">
      <div class="TipsNews-text">
        <div class="TipsNews-text-item">
          2021年4月1日停水信息
        </div>
        <div class="TipsNews-text-item">
          2021.3.23
        </div>
      </div>

      <van-icon name="arrow" class="TipsNews-back" />
    </div>

  </div>
</template>

<script>
  import TopBar from '@/components/TopBar';
  import { GoodsMixin } from '@/mixins/goodsMixin';
  import ajax from '@/api';
  export default {
    name: 'WaterRecord',
    mixins: [ GoodsMixin ],
    inject: [ 'reload' ],
    components: { TopBar },
    data() {
      return {

      }
    },
    watch: {

    },
    created() {

    },
    methods: {

    }
  }

</script>

<style lang="scss" scoped>
  @import "./style.scss";
</style>